import React from "react";

import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../services/CamplaCoreService";
import { Col, Container, Row, Table } from "react-bootstrap";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


class HardwareChecker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      myHardware: {
        Manufacturer: "-",
        Model: "-",
        SystemFamily: "-",
        SystemSKUNumber: "-"
      },
      matchedHardware: {
        product: null,
        standard: -1,
        hasSecured: false
      },
      isLoading: false
    };

    this.importantMetrics = new Set([
      "Model",
      "SystemFamily",
      "SystemSKUNumber"
    ]);

    this.lookupHardware = this.lookupHardware.bind(this);
  }

  componentDidMount() {
    const hardwareSpecifications = CamplaCoreService.getUrlParameter("lookup");
    if (hardwareSpecifications) {
      try {
        const parsedHardware = JSON.parse(hardwareSpecifications);
        const myHardware = Object.assign({}, this.state.myHardware);
        const patterns = [];
        for (let prop in this.state.myHardware) {
          if (typeof parsedHardware[prop] !== "undefined") {
            myHardware[prop] = parsedHardware[prop];
            if (this.importantMetrics.has(prop)) patterns.push(parsedHardware[prop].toLowerCase().trim());
          }
        }
        this.setState({ myHardware, isLoading: true });
        this.lookupHardware(patterns);
      } catch (err) {
        console.log(err);
      }
    }
  }

  async lookupHardware(patterns) {
    let bestMatch = null;
    let max = -1;
    try {
      const foundHardware = await CamplaCoreService.lookupHardwareByTags(patterns);
      foundHardware.forEach(hw => {
        let count = 0;
        patterns
          .filter(pat => hw.product.toLowerCase().indexOf(pat) >= 0)
          .forEach(() => count++);
        if (count > max) {
          max = count;
          bestMatch = hw;
        }
      });

      // No match found
      if (max < 1) bestMatch = null;
    } catch (err) {
      console.log(err);
    }
    if (bestMatch) {
      this.setState({
        matchedHardware: {
          product: bestMatch.product,
          testedOS: bestMatch.testedOS,
          hasSecured: bestMatch.hasTpmMode,
          standard: bestMatch.status
        },
        isLoading: false
      });
    } else {
      this.setState({ isLoading: false });
    }
    return bestMatch;
  }

  render() {
    const { t } = this.props;

    let standardColor = "text-white bg-color-black";
    let standardText = t("HardwareChecker.NoSupportData");
    let securedColor, securedText;
    switch (this.state.matchedHardware.standard) {
      case 0:
        standardColor = "text-white bg-color-red";
        standardText = t("HardwareChecker.NotSupported");
        break;
      case 1:
        standardColor = "text-black bg-color-yellow";
        standardText = t("HardwareChecker.PartialSupported");
        break;
      case 2:
        standardColor = "text-white bg-color-green";
        standardText = t("HardwareChecker.FullySupported");
        break;
      default:
        securedColor = this.state.matchedHardware.hasSecured ? "text-white bg-color-green" : "text-white bg-color-red";
        securedText = this.state.matchedHardware.hasSecured ? t("HardwareChecker.FullySupported") : t("HardwareChecker.NotSupported");
        break;
    }

    const table = this.state.isLoading ? (
      <p>
        <FontAwesomeIcon icon={faCircleNotch} spin /> {t("HardwareChecker.LookupHardware")}
      </p>
    ) : (
      <Table>
        <tbody>
        {this.state.matchedHardware.product ? (<tr>
          <td style={{ width: "200px" }}><b>{t("HardwareChecker.RowProduct")}:</b></td>
          <td>{this.state.matchedHardware.product}</td>
        </tr>) : ""}
        {this.state.matchedHardware.product ? (<tr>
          <td style={{ width: "200px" }}><b>{t("HardwareChecker.RowTestedOS")}:</b></td>
          <td>{this.state.matchedHardware.testedOS}</td>
        </tr>) : ""}
        <tr>
          <td style={{ width: "200px" }}><b>{t("HardwareChecker.RowStandardExamination")}:</b></td>
          <td className={standardColor}>{standardText}</td>
        </tr>
        <tr>
          <td><b>{t("HardwareChecker.RowSecuredExamination")}:</b></td>
          <td className={securedColor}>{securedText}</td>
        </tr>
        </tbody>
      </Table>
    );

    return (
      <>
        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("HardwareChecker.Title")}</h2>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <h5>{t("HardwareChecker.MyDevice")}</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table>
                <tbody>
                <tr>
                  <td style={{ width: "200px" }}><b>{t("HardwareChecker.RowManufacturer")}:</b></td>
                  <td>{this.state.myHardware.Manufacturer}</td>
                </tr>
                <tr>
                  <td><b>{t("HardwareChecker.RowModel")}:</b></td>
                  <td>{this.state.myHardware.Model}</td>
                </tr>
                <tr>
                  <td><b>{t("HardwareChecker.RowSystemFamily")}:</b></td>
                  <td>{this.state.myHardware.SystemFamily}</td>
                </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h5>{t("HardwareChecker.LookupResult")}</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              {table}
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default withTranslation()(HardwareChecker);
